import { styled } from "@mui/material";

export const ImageCarouselWrapper = styled("div")`
  display: block;
  height: 320px;
  overflow: hidden;
  position: relative;
  width: 100%;
  & [class*="carousel-background-image"] {
    display: block;
    display: flex;
    flex-direction: row;
    height: 320px;
    justify-content: center;
    width: 100%;

    & [class*="pagination"] {
      background: none;
      bottom: 10px;
      display: block;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      width: max-content;
      z-index: 3;
      & .MuiMobileStepper-dots {
        gap: 12px;
        & .MuiMobileStepper-dot {
          background-color: rgba(217, 217, 217, 0.5);
          height: 6px;
          width: 6px;
          &[class*="dotActive"] {
            background-color: rgba(217, 217, 217);
          }
        }
      }
    }
  }
`;
